import React from 'react'
import { stringToBool } from 'lib/utils/string'
import PropTypes from 'prop-types'

import FormElementOptionGroup from 'components/Forms/FormElements/FormElementOptionGroup'
import Option from 'components/Forms/FormElements/Option'

const RadioGroup = ({
    form,
    field,
    onChange,
    options,
    renderContent,
    className,
    validating,
    displayErrors,
    ...rest
}) => {
    const { name, value } = field
    const { touched, errors } = form
    const error = displayErrors && !validating && touched[name] && errors[name]

    const handleChange = (e) => {
        form.setFieldValue(name, stringToBool(e.target.value))
        onChange && onChange(e)
    }

    return (
        <FormElementOptionGroup
            name={name}
            className={className}
            error={error}
            {...rest}
        >
            {(props) => (
                options.map((option) => {
                    const selected = stringToBool(value) === option.value

                    return (
                        <React.Fragment key={option.value}>
                            <Option
                                id={name + '_' + option.value}
                                type="radio"
                                value={option.value}
                                text={option.name}
                                selected={selected}
                                onChange={handleChange}
                                description={option.description}
                            />
                            {renderContent && renderContent(option, selected)}
                        </React.Fragment>
                    )
                })
            )}
        </FormElementOptionGroup>
    )
}

RadioGroup.propTypes = {
    options: PropTypes.array.isRequired,
    form: PropTypes.object.isRequired,
    field: PropTypes.object.isRequired,
    renderContent: PropTypes.func,
    displayErrors: PropTypes.bool,
    className: PropTypes.string,
    label: PropTypes.string,
    orientation: PropTypes.oneOf(['vertical', 'horizontal']),
}

RadioGroup.defaultProps = {
    displayErrors: true,
}

export default RadioGroup
